var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#343434"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.4185C10.0736 15.7935 9.0609 16 8 16C6.9391 16 5.92643 15.7935 5 15.4185V0.581517C5.92643 0.206507 6.9391 0 8 0C9.0609 0 10.0736 0.206507 11 0.581517V15.4185Z",
    fill: "#FADF43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0.581543V15.4185C13.9318 14.2317 16 11.3574 16 8.00003C16 4.64265 13.9318 1.76832 11 0.581543Z",
    fill: "#E62048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8C15.75 12.2802 12.2802 15.75 8 15.75C3.71979 15.75 0.25 12.2802 0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8Z",
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })));
}

export default SvgBe;